import styles from "../DeliveryHighlights/DeliveryHighlights.module.scss";
import { ListWithIcon } from "../ListWithIcon";
import { FREE_CLICK_AND_COLLECT_THRESHOLD } from "@/components/DeliveryAndGuaranteesMessage/constants.ts";

export type ClickAndCollectMessageProps = {
  isClickAndCollectAvailable: boolean;
  isOverClickAndCollectThreshold: boolean;
};

export const ClickAndCollect = ({
  isClickAndCollectAvailable,
  isOverClickAndCollectThreshold,
}: ClickAndCollectMessageProps) => {
  if (!isClickAndCollectAvailable) {
    return (
      <ListWithIcon
        textMessage="Click & Collect not available for this item"
        cssClasses={styles.deliveryMessage}
        dataTestId="product:delivery-message:click-and-collect"
        iconType="info"
      />
    );
  }

  return (
    <ListWithIcon
      textMessage={`Free Click & Collect ${isOverClickAndCollectThreshold ? "" : ` over £${FREE_CLICK_AND_COLLECT_THRESHOLD}`}`}
      cssClasses={styles.deliveryMessage}
      dataTestId="product:delivery-message:click-and-collect"
      iconType="shop"
    />
  );
};
